import { type Media, MediaStatus } from '@/typings/graphql-models';

const isMediaReadyEnough = (media: Pick<Media, 'id' | 'mediaStatus'> | null): boolean =>
  Boolean(media && media.id && media.mediaStatus !== MediaStatus.Uploading && media.mediaStatus !== MediaStatus.Error);

export default isMediaReadyEnough;
